import React, { Component, Fragment } from 'react';
import EnhancedChildRecord from './EnhancedChildRecord';
import { Redirect } from 'react-router-dom';
import BootstrapTable from 'react-bootstrap-table-next';
import { childColumns } from '../Columns'

class ChildRecord extends Component {

  state = {
    records: []
  }

  handleNewRecord = (record) => {
    this.setState(prevState => ({
      records: [...prevState.records, record]
    }))
  }

  render() {
    const { state } = this.props.location;
    const { records } = this.state;

    if(state == undefined) {
      return (
        <Redirect to="/personalhealthrecord/childrecord" />
      )
    } 
    return (
      <Fragment>
        <EnhancedChildRecord 
          documentType={state.type}
          childId={state.childId}
          formType="add"
          handleNewRecord={this.handleNewRecord}
        />
        {records.length > 0 &&
          <div> 
            <h5>{`You have added ${records.length} record recently`}</h5>
            <BootstrapTable keyField="_id"
            data={records}
            columns={childColumns}
            wrapperClasses="table-responsive"
            headerClasses="tableHeader"
            />
          </div>
        }
      </Fragment>
    )
  }
}

export default ChildRecord;


// WEBPACK FOOTER //
// ./src/views/PersonalHealthRecord/ChildRecord/ChildRecord.js